import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { timer } from 'rxjs/observable/timer';

import { AnalyticsProvider } from '../providers/analytics/analytics';
import { ErrorReportingProvider } from './../providers/error-reporting/error-reporting';
import { LoadingAlertProvider } from '../providers/loading-alert/loading-alert';
import { LoginPage } from './../pages/login/login';
import { OpsTabsPage } from './../pages/ops-tabs/ops-tabs';
import { UserModel } from '../models/user';
import { UserProvider } from '../providers/user/user';

@Component({
  templateUrl: 'app.html',
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any;
  menuEnabled = false;
  showSplash = true;
  currentPage: string;
  pages: Array<{ title: string; component: any }>;
  user: UserModel;
  alertCount = 0;
  isAppOpenTracked: boolean = false;

  constructor(
    private platform: Platform,
    private userService: UserProvider,
    private analytics: AnalyticsProvider,
    private errorReporting: ErrorReportingProvider,
    private loadingAlertCtrl: LoadingAlertProvider
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.subscribeForHomePageUpdates();
      this.subscribeToLogin();
      this.animateSplash();
      this.analytics.setup();
      this.errorReporting.init();
    });
  }

  subscribeForHomePageUpdates() {
    this.userService.isLoggedIn$.subscribe(loggedIn => {
      this.configureHomePage(loggedIn);
    });
  }

  configureHomePage(loggedIn: boolean) {
    if (loggedIn) {
      this.userService.currentUser$
        .filter(user => user !== null)
        .take(1)
        .subscribe(user => {
          if (!user.filler && !user.provider) {
            this.loadingAlertCtrl.showToastAlert(
              'Unauthorized Access to the Ops App.'
            );
            this.userService.logout();
            this.rootPage = LoginPage;
          } else {
            this.rootPage = OpsTabsPage;
          }
        });
    } else {
      this.rootPage = LoginPage;
    }
  }

  subscribeToLogin() {
    this.userService.isLoggedIn$.subscribe(loggedIn => {
      if (loggedIn) {
      }
    });
  }

  // Splash

  animating = false;

  private animateSplash() {
    this.showSplash = true;
    this.animating = false;
    timer(300).subscribe(() => {
      this.animating = true;
      timer(3000).subscribe(() => {
        this.showSplash = false;
        this.animating = false;
      });
    });
  }

  // Navigation

  openPage(page) {
    this.nav.setRoot(page.component);
    this.currentPage = page.title;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts